export enum EColor {
  MONOCHROME,
  RED,
  GREEN,
  BLUE,
}
